import React from "react";
import "./ScreenHeader.css";

const ScreenHeader = ({ actions, title, description }) => {
  return (
    <header className="new-hrm-screen-header">
      <div className="new-hrm-screen-header__copy">
        <h1 className="new-hrm-screen-header__title">{title}</h1>
        {description && <span className="new-hrm-screen-header__description">{description}</span>}
      </div>
      {actions && <div className="new-hrm-screen-header__actions">{actions}</div>}
    </header>
  );
};

export default ScreenHeader;
